/**
 * Mensagem de confirmação ao excluir canal (2026-09-15). Em 01/09 um canal
 * usado pelo workflow de pós-venda foi excluído sem ninguém saber que ele era
 * usado ali; a pausa automática desligou o workflow calada. Agora a confirmação
 * diz quais workflows ativos serão pausados.
 */
export function mensagemExclusaoCanal(workflows: Array<{ id: string; name: string }>, quantidadeDeCanais: number): string {
  const unicos = [...new Map(workflows.map((w) => [w.id, w])).values()];
  const nomes = unicos.map((w) => `"${w.name}"`).join(', ');
  const efeito =
    unicos.length === 1
      ? 'Ao excluir, ele será pausado e só volta a funcionar depois de você escolher outro canal nele.'
      : 'Ao excluir, eles serão pausados e só voltam a funcionar depois de você escolher outro canal neles.';

  if (quantidadeDeCanais > 1) {
    if (unicos.length === 0) return `Excluir ${quantidadeDeCanais} canal(is) selecionado(s)?`;
    const quem = unicos.length === 1 ? `Um deles é usado pelo workflow ativo ${nomes}.` : `Eles são usados por ${unicos.length} workflows ativos: ${nomes}.`;
    return `Excluir ${quantidadeDeCanais} canais selecionados? ${quem} ${efeito}`;
  }

  if (unicos.length === 0) return 'Tem certeza que deseja deletar este canal?';
  const quem = unicos.length === 1 ? `Este canal é usado pelo workflow ativo ${nomes}.` : `Este canal é usado por ${unicos.length} workflows ativos: ${nomes}.`;
  return `${quem} ${efeito} Excluir mesmo assim?`;
}
